import { WidgetTypeEnum } from "../../common/enum";

export default class WidgetBaseDetailModel {
	public id: string;
	public type: WidgetTypeEnum | string;
	public label: string;
	public variableName: string;
	public orderId: number; // required to maintain widget sequence, generate unique id for widget
	public isValidated: boolean; // required for studio-flow validation

	public constructor() {
		this.id = "";
		this.type = "";
		this.label = "";
		this.variableName = "";
		this.orderId = -1;
		this.isValidated = false;
	}
}
